<template>
  <div id="listener_workorder">
    <v-overlay :value="caricamento_dati">
      <v-icon class="ruota" size="100">mdi-cog</v-icon>
      <v-icon class="controruota" size="100">mdi-cogs</v-icon>
    </v-overlay>

    <!-- Componenti per i WO presenti -->
    <v-card flat>
      <v-card-text>
        <v-container>
          <v-row dense>
            <v-col v-for="(filtro, idx) in filtri" :key="idx" cols="4">
              <v-autocomplete
                dense
                v-if="filtro.tipo == 'T'"
                :label="filtro.text"
                :items="filtro.values"
                v-model="filtro.value"
                clearable
                clear-icon="mdi-filter-off"
                @change="filterItems"
              >
              </v-autocomplete>
              <v-row v-else-if="filtro.tipo == 'N'" dense>
                <v-col cols="6">
                  <v-text-field
                    dense
                    :label="filtro.text + ' da'"
                    type="number"
                    v-model="filtro.value"
                    clearable
                    clear-icon="mdi-filter-off"
                    @change="filterItems"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    dense
                    :label="filtro.text + ' a'"
                    type="number"
                    v-model="filtro.value2"
                    clearable
                    clear-icon="mdi-filter-off"
                    @change="filterItems"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-else-if="filtro.tipo == 'D'" dense>
                <v-col cols="6">
                  <v-text-field
                    dense
                    :label="filtro.text + ' da'"
                    type="date"
                    v-model="filtro.value"
                    clearable
                    clear-icon="mdi-filter-off"
                    @change="filterItems"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    dense
                    :label="filtro.text + ' a'"
                    type="date"
                    v-model="filtro.value2"
                    clearable
                    clear-icon="mdi-filter-off"
                    @change="filterItems"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
        <div :key="listKey">
          <v-container fluid>
            <!-- Ingresso della dashboard vera e propria -->
            <WorkorderLayoutRow
              @button_click="handleButtonClick"
              :gestione_team_enabled="gestione_team_enabled"
              :key="j"
              :riga="riga"
              v-for="(riga, j) in colonne[0].righe.filter(
                (r) => r.validita == 1 && r.intestazione == 1
              )"
              :workorder="{ tipo: 'intestazione' }"
            />
          </v-container>

          <v-container
            fluid
            :key="i"
            v-for="i in itemsPerPage"
            v-show="i - 1 + (pagina - 1) * itemsPerPage < filtered_items.length"
          >
            <!-- Ingresso della dashboard vera e propria -->
            <WorkorderLayoutRow
              @button_click="handleButtonClick"
              :gestione_team_enabled="gestione_team_enabled"
              :key="j"
              :riga="riga"
              v-for="(riga, j) in colonne[0].righe.filter(
                (r) => r.validita == 1 && r.intestazione == 0
              )"
              :workorder="
                filtered_items[
                  Math.min(
                    i - 1 + (pagina - 1) * itemsPerPage,
                    filtered_items.length - 1
                  )
                ]
              "
              :hasIntestazione="
                colonne[0].righe.filter(
                  (r) => r.validita == 1 && r.intestazione == 1
                ).length > 0
                  ? 1
                  : 0
              "
            />
          </v-container>
        </div>
        <v-row align="center" justify="center" dense>
          <v-col cols="1">
            <v-btn small @click="changePage(-1)">
              <v-icon color="primary">mdi-arrow-left</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="1">
            <h3>Pagina</h3>
          </v-col>
          <v-col cols="1">
            <v-text-field
              dense
              class="mt-3"
              v-model="pagina"
              type="number"
              @change="changePage(0)"
            ></v-text-field>
          </v-col>
          <v-col cols="1">
            <h3>
              {{
                "di " +
                Math.ceil(filtered_items.length / itemsPerPage).toString()
              }}
            </h3>
          </v-col>
          <v-col cols="1">
            <v-btn small @click="changePage(1)">
              <v-icon color="primary">mdi-arrow-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import ProduzioneColumnObject from "@/classes/ProduzioneColumnObject.js";
import ProduzioneDetailObject from "@/classes/ProduzioneDetailObject.js";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "",
  components: {
    WorkorderLayoutRow: () =>
      import("@/components/WorkorderLayout/WorkorderLayoutRow.vue"),
    SnackbarQV,
  },
  props: {
    back_as_landing_page: {
      type: Boolean,
      default: true,
    },
    items_consuntivo: { type: Array, default: () => [] },
    avvio_multiplo_enabled: {
      type: Number,
      default: 0,
    },
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      filtered_items: [],
      caricamento_dati: false,
      pagina: 1,
      itemsPerPage: 10,
      // Variabili d'appoggio
      listKey: true,
      work_order_sel: null,
      cod_turno_sel: "",
      gestione_team_enabled: 0,
      isAdmin: false,
      nome_utente: localStorage.getItem("nominativo"),
      request_counter: 0,

      // Modal
      dialog_turni_visible: false,

      // Array
      colonne: [new ProduzioneColumnObject()],
      filtri: [],
    };
  },
  computed: {},
  watch: {
    request_counter: {
      immediate: true,
      handler() {
        if (this.request_counter <= 0) {
          this.caricamento_dati = false;
        } else {
          this.caricamento_dati = true;
        }
      },
    },
  },
  methods: {
    changePage(n) {
      this.pagina = this.pagina + n;
      if (this.pagina < 1) {
        this.pagina = 1;
      } else if (
        this.pagina > Math.ceil(this.filtered_items.length / this.itemsPerPage)
      ) {
        this.pagina = Math.ceil(this.filtered_items.length / this.itemsPerPage);
      }
      this.listKey = !this.listKey;
    },
    filterItems() {
      this.pagina = 1;
      this.filtered_items = [];
      var toAdd = true;
      for (const item of this.items_consuntivo) {
        for (const filter of this.filtri) {
          if (
            filter.tipo == "T" &&
            filter.value != null &&
            filter.value != item[filter.field]?.toString()
          ) {
            toAdd = false;
          } else if (
            filter.tipo == "N" &&
            ((filter.value != null &&
              parseFloat(filter.value) >
                parseFloat(item[filter.field]?.toString())) ||
              (filter.value2 != null &&
                parseFloat(filter.value2) <
                  parseFloat(item[filter.field]?.toString())))
          ) {
            toAdd = false;
          } else if (
            filter.tipo == "D" &&
            ((filter.value != null &&
              Date.parse(filter.value) >
                Date.parse(
                  this.checkDateFormat(item[filter.field]?.toString())
                )) ||
              (filter.value2 != null &&
                Date.parse(filter.value2) <
                  Date.parse(
                    this.checkDateFormat(item[filter.field]?.toString())
                  )))
          ) {
            toAdd = false;
          }
        }
        if (toAdd) {
          this.filtered_items.push(JSON.parse(JSON.stringify(item)));
        }
        toAdd = true;
      }
      this.listKey = !this.listKey;
    },
    checkDateFormat(arg) {
      if (arg.includes("/")) {
        return `${arg.split("/")[2]}-${arg.split("/")[1]}-${arg.split("/")[0]}`;
      } else if (arg.includes("-")) {
        return arg;
      } else {
        return null;
      }
    },
    handleButtonClick(text, item, codice_btn, query) {
      this.$emit("button_click", text, item, codice_btn, query);
    },
    formatObjects(arr) {
      // Pero ogni colonna di questo array...
      for (let c = 0; c < arr.length; c++) {
        // ... Se ha degli oggetti...
        if (arr[c].oggetto) {
          // ... Controlla la struttura di ogni oggetto.
          for (let o = 0; o < arr[c].oggetto.length; o++) {
            if (
              typeof arr[c].oggetto[o].filtrabile != "undefined" &&
              arr[c].oggetto[o].filtrabile != null &&
              arr[c].oggetto[o].filtrabile == 1
            ) {
              this.filtri.push({
                text: arr[c].oggetto[o].text,
                field: arr[c].oggetto[o].value,
                value: null,
                value2: null,
                values: [],
                tipo: arr[c].oggetto[o].tipo_valore,
              });
            }
            this.$set(
              arr[c].oggetto,
              o,
              new ProduzioneDetailObject(arr[c].oggetto[o])
            );
          }
        } else {
          /* Se non ha un oggetto, gli metto l'array
           * per comodità e uniformità dei dati in FE. */
          arr[c].oggetto = new Array();
        }

        // Se ci sono righe nella colonna...
        if (arr[c].righe) {
          // ... Per ogni riga...
          for (let r = 0; r < arr[c].righe.length; r++) {
            // ... Se la riga contiene colnne...
            if (arr[c].righe[r].colonne) {
              // ... Lancia questa funzione su ogni colonna.
              this.formatObjects(arr[c].righe[r].colonne);
              this.setFilters();
            }
          }
        }
      }
    },
    setFilters() {
      for (const filter of this.filtri) {
        for (const item of this.items_consuntivo) {
          if (!filter.values.includes(item[filter.field])) {
            if (
              typeof item[filter.field] != "undefined" &&
              item[filter.field] != null
            ) {
              filter.values.push(item[filter.field].toString());
            }
          }
        }
      }
    },
    async getLayoutAssociazioni() {
      this.request_counter++;
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getlayoutassociazioni",
          token: localStorage.user_token,
          id_profilo: localStorage.id_profilo,
          modulo: "SceltaWO",
        },
      };

      await this.$store
        .dispatch("api", request)
        .then(async (res) => {
          this.request_counter--;
          // Se la risposta è in 200...
          if (res.status === 200) {
            await this.getLayoutStruttura(
              res.data.result.associazioni[0].id_layout
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          this.request_counter--;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    async getLayoutStruttura(arg) {
      this.request_counter++;
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getlayoutstruttura",
          token: localStorage.user_token,
          id_layout: arg,
        },
      };

      await this.$store
        .dispatch("api", request)
        .then((res) => {
          this.request_counter--;
          // Se la risposta è in 200...
          if (res.status === 200) {
            const arr_tmp = [new ProduzioneColumnObject(res.data.result)];

            /* Se il layout è vuoto, di per sé il BE non me lo restituisce con un
             * id_layout e id_layout_tmp. In questo caso avviso che la dashboard è
             * vuota con una snackbar. */
            if (!res.data.result) {
              this.$refs.SnackbarQV.print(
                "orange",
                "La dashboard associata a questo profilo non contiene strutture."
              );
            }

            this.formatObjects(arr_tmp);

            // Registro la struttura del layout.
            this.$set(this.colonne, 0, new ProduzioneColumnObject(arr_tmp[0]));

            // Registro il titolo del layout selezionato.
            this.titolo_layout_sel = arg.titolo;

            // Chiudo il dialog di caricamento.
            this.dialog_caricamento = false;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          this.request_counter--;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getPulsantiCruscotto() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getpulsantiheader",
          token: localStorage.user_token,
          tipo_oggetto: "B",
          nome_modulo: "AVANZAMENTO",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            /* Verifico che il pulsante degli avvii multipli sia abilitato,
             * poi lo cancello perché per il cruscotto di avanzamento non avrebbe
             * senso di esistere sulle varie righe. (Il tasto di avvio multiplo
             * dei WO non deve stare nello spazio dei WO ma in una toolbar e deve
             * essere sempre solo un pulsate, per questo lo cancellerò con le
             * istruzioni qui sotto.) Faccio un ragionamento analogo anche per
             * il pulsante di lavoro squadra, che se è visibile deve far scattare
             * una chiamata particolare quando si stoppa il WO. */
            res.data.forEach((b) => {
              if (b.text === "Avvio Multiplo WO") {
                this.$emit("config_avvio_multiplo_wo", b.visible);
              } else if (b.text === "Lavoro Squadra") {
                this.gestione_team_enabled = b.visible;
              }
            });

            /* Se presente, emetto l'id_header_query in modo che il componente
             * padre lo possa passare in prop ai componenti che ne hanno bisogno. */
            res.data.forEach((d) => {
              if (d.query != null) {
                this.$emit("id_header_query", d.id_header);
              }
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
  },
  created() {},
  async mounted() {
    this.isAdmin = localStorage.getItem("id_profilo") == 1;

    // Preparo i listener.
    document
      .getElementById("listener_workorder")
      .addEventListener("cambiata_macchina", this.cambiaMacchina);

    document
      .getElementById("listener_workorder")
      .addEventListener("prelievo_registrato", this.aggiornaPrelievi);

    await this.getLayoutAssociazioni();
    this.filtered_items = this.items_consuntivo;

    // Carico i filtri dalle sessioni precedenti.
    /*if (
      localStorage.filtri_scelta_WO !== undefined &&
      JSON.parse(localStorage.filtri_scelta_WO).length > 0
    ) {
      const filtri_tmp = JSON.parse(localStorage.filtri_scelta_WO);
      filtri_tmp.forEach((ftmp) => {
        this.filtri.forEach((f) => {
          if (f.field == ftmp.field) {
            if (f.tipo == "T" && f.values.includes(ftmp.value)) {
              f.value = ftmp.value;
            } else {
              f.value = ftmp.value;
              f.value2 = ftmp.value2;
            }
          }
        });
      });
      this.filterItems();
    }*/
  },
};
</script>
<style scoped>
@keyframes controtazione {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes rotazione {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.controruota {
  animation: controtazione 1s infinite;
  animation-timing-function: linear;
}
.ruota {
  animation: rotazione 1s infinite;
  animation-timing-function: linear;
}
#listener_workorder {
  font-size: 20px;
  text-align: center;
}
#listener_workorder .button {
  height: 70px;
  width: 70px;
  min-width: 70px;
}
#listener_workorder .evidenziato {
  background-color: pink;
}
#listener_workorder .v-list-item {
  padding: 0;
}
#listener_workorder .v-divider {
  border-color: #3f51b5;
  border-width: 2px;
}
#listener_workorder .label {
  color: #3f51b5;
  margin-bottom: 7px;
}

@media screen and (max-width: 900px) {
  #listener_workorder {
    font-size: 18px;
  }
  #listener_workorder .button {
    height: 65px;
    width: 65px;
    min-width: 65px;
  }
}
@media screen and (max-width: 840px) {
  #listener_workorder {
    font-size: 16px;
  }
  #listener_workorder .button {
    height: 60px;
    width: 60px;
    min-width: 60px;
  }
}
</style>
<style scoped>
@keyframes controtazione {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes rotazione {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.controruota {
  animation: controtazione 1s infinite;
  animation-timing-function: linear;
}
.ruota {
  animation: rotazione 1s infinite;
  animation-timing-function: linear;
}
</style>